module.exports = __webpack_public_path__ + "static/media/6e_website_logo_Platinum_kone.5a221eca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/6e_website_logo_Platinum_kone.jpg
// module id = 100
// module chunks = 0